import role from '../helpers/role';

import EventRegistrationList from '../components/eventRegistration/EventRegistrationList.vue';
import NewEventRegistration from '../components/eventRegistration/NewEventRegistration.vue';


const routes = [{
	path: '/eventregistration',
	name: 'eventregistration',
	component: EventRegistrationList,
	meta: {
		authorize: [{ name: role.Any }],
	},
}, {
	path: '/neweventregistration',
	name: 'neweventregistration',
	component: NewEventRegistration,
	meta: {
		authorize: [{ name: role.Any }],
		parentName: 'eventregistration',
	},
}, {
	path: '/updateeventregistration/:eGuid',
	name: 'updateeventregistration',
	component: NewEventRegistration,
	meta: {
		authorize: [{ name: role.Any }],
		parentName: 'eventregistration',
	},
}];

export default routes;
